const dataUpload = {
  wizard: {
    fileUpload: {
      title: '1. העלאת קובץ',
      body: {
        btn: 'העלה',
        hint: 'בחר את קובץ ה-CSV שברצונך לייבא',
        downloadExample: 'הורד דוגמת CSV',
        templateLabel: 'בחר תבנית מיפוי (אופציונלי)',
        templateDescription: 'התבנית נטענה. ניתן לצפות או לערוך את ההגדרות למטה במידת הצורך.',
        advanced: {
          hint: 'בחר את הקבצים שברצונך לייבא',
        },
      },
    },
    mappingFields: {
      title: '2. מיפוי שדות',
      subTitle: 'אשר שכל מאפיין תואם לעמודה הנכונה',
      toast: 'ערך משוכפל',
      selectInputPlaceHolder: 'בחר שדה'
    },
    integrityCheck: {
      title: '3. בדיקת תקינות',
      subTitle: 'בודק את ערכי הקובץ',
    },
    import: {
      title: '4. ייבוא',
      subTitle: 'ייבא את הנתונים',
      doneText: 'הקובץ יובא בהצלחה',
      doneBtn: 'בוצע',
    },
  },

  mappingFields: {
    table: {
      fieldsInDb: 'שדות בבסיס הנתונים',
      csvFile: 'קובץ CSV',
      format: 'פורמט',
      defaultValue: 'ערך ברירת מחדל',
    },
    hideTableBtn: 'הסתר טבלה',
    showTableBtn: 'הצג טבלה',
    saveAsTemplateBtn: 'שמור כתבנית',
    templateNameLabel: 'שם תבנית',
    saveTemplateDescription: 'שמור את מיפויי השדות הנוכחיים שלך כתבנית לשימוש עתידי.',
    updateTemplateDescription: 'אפשר לעדכן את התבנית הקיימת {{templateName}} או לשמור כתבנית חדשה.',
    saveTemplateBtn: 'שמור',
    saveAsNewBtn: 'שמור כחדש',
    updateTemplateBtn: 'עדכן תבנית',
    nextBtn: 'הבא',
  },

  integrityCheck: {
    showOnlyProblemBtn: 'הצג רק בעיות',
    disableSubmit: 'דלג על שגיאות',
    totalCount: 'סה"כ: {{count}}',
    exportErrorList: 'ייצא רשימת שגיאות',
    rowContainErroe: '{{count}} שורות מכילות שגיאות.',
    importBtn: 'ייבא',
    sourceFileColumn: 'קובץ מקור',
    sourceRowColumn: 'שורת מקור',
    sourceFileFilterAll: 'כל {{count}} קבצי המקור',
  },

  submit: {
    errors: '{{errors}} שורות נכשלו בדחיפה',
  }
};

export default dataUpload;
